module.exports = __webpack_public_path__ + "img/implementation-icon.d9925a8a.svg";